import { isTransactableSettled } from '@src/domains/transactables/core/isTransactableSettled';
import { resolveTransactableAmountCents } from '@src/domains/transactables/core/resolveTransactableAmountCents';
import { resolveTransactableEntity } from '@src/domains/transactables/core/resolveTransactableEntity';
import type { Transactable } from '@src/domains/transactables/types/transactable';

export type TransactableSettlement = {
  id: string;
  method?: string;
  totalPriceCents: number;
};

/**
 * What was paid, once the purchase settles — whichever of the four shapes it is. All of them carry
 * an id, the transaction that paid them and a total, so the only thing that differs between them is
 * when each counts as settled, which `isTransactableSettled` holds.
 */
export const resolveTransactableSettlement = (tr: Transactable): TransactableSettlement | undefined => {
  const entity = resolveTransactableEntity(tr);

  if (!entity || !isTransactableSettled(tr)) {
    return undefined;
  }

  return {
    id: entity.id,
    method: entity.lastTransaction?.paymentMethod.code,
    totalPriceCents: resolveTransactableAmountCents(tr),
  };
};
